import { apiGetRequest, apiPostRequest } from "../utils/webrequests";
import { SocialMediaPlatformInfo } from "../data/socialMediaData";

export async function getSocialMediaInfo(): Promise<SocialMediaPlatformInfo[]> {
  try {
    // Make an API GET request to fetch social media info
    const data: SocialMediaPlatformInfo[] | undefined = await apiGetRequest(
      "GetSocialMediaPlatforms",
      null
    );

    // Check if data is undefined or null
    if (!data) {
      throw new Error("No data received from API");
    }

    return data; // Return the fetched data
  } catch (error: any) {
    throw new Error("Error fetching social media info: " + error.message); // Throw an error if fetching fails
  }
}
export async function updateSocialMediaInfo(
  socialMediaInfo: SocialMediaPlatformInfo[]
): Promise<any> {
  try {
    await apiPostRequest("SocialMediaPlatforms", socialMediaInfo);
  } catch (error: any) {
    throw new Error("Error updating social media info: " + error.message);
  }
}

export async function deleteSocialMediaInfo(
  deletedRow: SocialMediaPlatformInfo
): Promise<void> {
  try {
    await apiPostRequest("RemoveSocialMediaPlatforms", deletedRow); // Pass the entire deletedRow object
  } catch (error: any) {
    throw new Error("Error deleting social media info: " + error.message);
  }
}
